var _path, _path2, _circle, _circle2, _circle3, _circle4, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2861H60V50.0004C60 55.5233 55.5228 60.0004 50 60.0004H10C4.47715 60.0004 0 55.5233 0 50.0004V16.2861Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H50C55.5228 0 60 4.47715 60 10V18H0V10Z",
    fill: "#5F39CA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4286,
    cy: 43.4286,
    r: 3.42857,
    fill: "#D4D4D4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4286,
    cy: 29.4286,
    r: 3.42857,
    fill: "#5F39CA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4286,
    cy: 29.4286,
    r: 3.42857,
    fill: "#D4D4D4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4286,
    cy: 43.1424,
    r: 3.42857,
    fill: "#5F39CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 32V27L16.5 30.3696L21 27V32",
    stroke: "#5F39CA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45V40L31.5 43.3696L36 40V45",
    stroke: "#5F39CA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.167f2873a358562aba68fb9e455fe176.svg";
export { ForwardRef as ReactComponent };